import React from 'react';
import dynamic from 'next/dynamic';
import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import { PageContentElementListicles as PageContentElementListiclesType } from '@src/lib/graphql/generated';

const Listicles = dynamic(() => import('@components/organisms/Listicles/Listicles').then((module) => module.Listicles));

export const PageContentElementListicles = (element: PageContentElementListiclesType & { dataSet: [] }, index) => {
  return (
    <div className="relative pl-4 sm:pl-8 lg:pl-16">
      <ShowAllTitle title={element.title} link={element.title_link} linkText={element?.custom_link_text} />
      <Listicles
        listicle_type={element.listicle_type}
        limit={parseInt(element.limit)}
        genre_filter={element.genre_filter}
        items={element.items}
        query={element.query}
        dataSet={element.dataSet ?? []}
        onlyWithAsset={element.onlyWithAssets}
        onlyPrimetime={element.onlyPrimetime}
        showInitially={index < 3}
        provider_filter={element.provider_filter}
        searchterm={element.searchterm}
      />
    </div>
  );
};

export default PageContentElementListicles;
